import React from 'react';
import { PageTypeTitle } from '../PageType';
import { ICategory } from '../../../types/ICategory';
import { PageType } from '../../../types/api/PageType';
import { useSonTranslation } from '../../../translation/useSonTranslation';
import { Modifier } from '../../../lib/bemUtils/Modifier';
import bem from '../../../lib/bemUtils/bem';
import { hasTranslation } from '../PageType/PageTypeTitle';
import { InvisiblyDefinedTerm } from '../InvisiblyDefinedTerm';

function normalizeCategories(categories?: ICategory[]) {
  return categories?.map(category => category.title).join(', ');
}

export type PageConnectionDetails = {
  modifier?: Modifier<'padding-bottom'>;
  pageType?: PageType;
  categories?: ICategory[];
  roles?: string | string[];
};

/**
 * Details of a Page
 */
export function PageConnectionDetails({ modifier, pageType, categories, roles }: PageConnectionDetails) {
  const { t } = useSonTranslation('glossary');

  const hasCategories = categories && categories.length > 0;

  return (
    <div className={bem('page-connection-details', modifier)}>
      {(hasCategories || pageType) && (
        <p>
          {pageType && hasTranslation(pageType) && (
            <>
              <dfn className="invisible">{t('pageType')}: </dfn>
              <span>
                <PageTypeTitle pageType={pageType} />
              </span>{' '}
            </>
          )}
          {hasCategories && (
            <>
              <dfn className="invisible">{t('category')}: </dfn>
              <span>({normalizeCategories(categories)})</span>
            </>
          )}
        </p>
      )}
      {roles && (
        <InvisiblyDefinedTerm definition={t('connectionType')}>
          {Array.isArray(roles) ? roles.join(', ') : roles}
        </InvisiblyDefinedTerm>
      )}
    </div>
  );
}
